import { cx } from '../lib/cx';

export default function Image({ src, alt = '', className, style, ...props }) {
  return <img src={src} alt={alt} className={className} style={style} {...props} />;
}

export function Video({ src, playbackRate, className, ...props }) {
  return (
    <video
      src={src}
      autoPlay
      loop
      muted
      playsInline
      playbackrate={playbackRate || undefined}
      className={className}
      {...props}
    />
  );
}
